import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=383fff99"
import script from "./TableCell.vue?vue&type=script&lang=ts"
export * from "./TableCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports